import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import RightSideNavigation from "../../vendorDashboardComponents/navigationSection/RightSideNavigation";
import { QRCode } from "react-qr-svg";
import axios from "axios";
import { serverApi } from "../../../config/Keys";
import LoadingGif from "../../../assets/images/ActionImages/loadingPublicGif.gif";
import { PAYMENT_STATUS } from "../../../enums/OrderEnums";
import moment from "moment";
import { downloadToJPEG } from "../QRCodePrintAndExport/DownloadImages";
import { DEFAULT_ITEM_IMAGE } from "../../../enums/GlobalEnums";
import { NOTAVAILABLEIMAGE } from "../../../enums/GlobalEnums";
import LOGO_MAIN from "../../../assets/images/Login/logo.png";
import Media from "react-media";

function EventQrCodePublicDisplay(props) {
  const [data, setData] = useState({});
  const [status, setStatus] = useState(0);
  useEffect(() => {
    let getData = async () => {
      if (props?.match?.params?.id) {
        try {
          let response = await axios.get(
            `${serverApi}/vendor/event-handler/${props?.match?.params?.id}`
          );
          if (response.status === 200 && response?.data?.event_id) {
            setData(response.data);
            setStatus(1);
          } else {
            setStatus(2);
          }
        } catch (e) {
          setStatus(2);
        }
      }
    };
    getData();
  }, [props?.match?.params?.id]);

  // const [flag, setFlag] = useState(true);

  // if (data?.event_id && flag) {
  //   setTimeout(() => {
  //     downloadToJPEG(
  //       document.getElementById("print-component"),
  //       data?.event_request_id,
  //       () => {
  //         console.log("Success Download...!");
  //       },
  //       (err) => {
  //         console.log(err);
  //       }
  //     );
  //   }, [1000]);

  //   setFlag(false);
  // }
  return (
    <React.Fragment>
      <Container
        fluid
        // className="mobile-pt-12vh mb-4"
        style={{ background: "#fff", backgroundColor: "#fff" }}
      >
        <Row>
          <div className="right-side-panel w-100">
            {/* <RightSideNavigation noHamburgerMenu /> */}
            <div className="container text-break">
              <div
                id="print-component"
                style={{ background: "#fff", backgroundColor: "#fff" }}
                className="web-p-3"
              >
                <div className="f14-400 d-flex align-items-center">
                  <div>Powered by </div>{" "}
                  <div>
                    <img
                      src={LOGO_MAIN}
                      className="img-fluid profile-image-menu p-1"
                      style={{ width: "150px" }}
                      alt="Amealio Logo"
                      title="Amealio Logo"
                    />
                  </div>
                </div>
                {status === 0 && (
                  <div align="center">
                    <Image src={LoadingGif} width={"50%"} height={"50%"} />
                  </div>
                )}
                {status === 2 && (
                  <div align="center">
                    <div className="f20-500">Event Not Found</div>
                    <div className="f14-400">Please check the link</div>
                  </div>
                )}
                {status === 1 && (
                  <>
                    <div className="shadow-sm border p-4 mb-2 bg-white rounded">
                      {/* <div className="f18-500">Ticket Details</div> */}
                      <div className="row">
                        <div style={{ overflow: "hidden" }} className="col-3">
                          <Image
                            src={
                              data?.event_id?.photos.length > 0
                                ? data?.event_id?.photos[0]
                                : NOTAVAILABLEIMAGE
                            }
                            style={{
                              margin: "0px -12px -12px 0px",
                              maxWidth: "100%",
                              height: "200px",
                            }}
                            title="Event Logo"
                            alt="Event Logo"
                          />
                        </div>
                        <div className="col-md-7 col-9">
                          <div className="f16-500">
                            {data?.event_id?.name || ""}
                          </div>
                          <div className="f14-400 mt-2">
                            Event ID: {data?.event_id?.event_id}
                          </div>
                          <Row className="mt-3">
                            <Col md={4} xs={12} className="mobile-mb-4">
                              <div className=" border-right">
                                <div className="f14-400 mb-1">Event Date</div>
                                <div className="f14-500">
                                  {" "}
                                  {moment(data?.event_id?.start_date).format(
                                    "Do MMM, YYYY"
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col md={4} xs={6}>
                              <div className=" border-right">
                                <div className="f14-400 mb-1">Event Time</div>
                                <div className="f14-500">
                                  {moment(data?.event_id?.start_date).format(
                                    "hh:mm A"
                                  )}
                                </div>
                              </div>
                            </Col>

                            <Col md={4} xs={6}>
                              <div className="">
                                <div className="f14-400 mb-1">Event Venue</div>
                                <div className="f14-500">
                                  {data?.event_id?.venue_address}
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="mt-2">
                            <Col md={4} xs={6}>
                              <div className="border-right">
                                <div className="f14-400 mb-1">Name</div>
                                <div className="f14-500">
                                  {data?.user_details?.name || ""}
                                </div>
                              </div>
                            </Col>
                            <Col md={4} xs={6}>
                              <div className="">
                                <div className="f14-400 mb-1">Party Size</div>
                                <div className="f14-500">
                                  Adult - {data.adult_count} | Kids -{" "}
                                  {data.kids_count}
                                </div>
                              </div>
                            </Col>
                            <Col md={4} xs={6}>
                              <div className="">
                                <div className="f14-400 mb-1">Seat Number</div>
                                <div className="f14-500 d-flex align-items-center">
                                  {data?.seat_number.map((data, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        {data},&nbsp;
                                      </React.Fragment>
                                    );
                                  })}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <Media query="(min-width: 992px)">
                          <div className="col-2" align="right">
                            <Button
                              variant="link"
                              style={{ color: "black" }}
                              className="popup-icon-edit-button-small p-3  mr-3"
                              onClick={() => window.print()}
                            >
                              <i class="fa fa-print" aria-hidden="true"></i>
                            </Button>
                          </div>
                        </Media>
                      </div>
                      <br />
                      <div>
                        <Row>
                          <Col md={12} xs={8}>
                            <div className="mb-2 d-flex align-items-center">
                              <div className="f16-500">
                                Event Ticket Details{" "}
                              </div>
                              <div className="ml-3">
                                <div
                                  className="f12-400 badge badge-warning px-3 py-1"
                                  style={{ borderRadius: 25 }}
                                >
                                  TICKET
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Media query="(max-width: 991px)">
                            <div className="col-2" align="right">
                              <Button
                                variant="link"
                                style={{ color: "black" }}
                                className="popup-icon-edit-button-small p-3  mr-3"
                                onClick={() => window.print()}
                              >
                                <i class="fa fa-print" aria-hidden="true"></i>
                              </Button>
                            </div>
                          </Media>
                        </Row>
                        <div className="d-flex mt-2 mb-3">
                          <div className="f14-400">Ticket Number:</div>
                          <div className="f14-500 ml-2">
                            {data?.event_request_id}
                          </div>
                        </div>
                        <div
                          className="resQRCode"
                          style={{
                            width: "15vh",
                            height: "15vh",
                            margin: "inherit",
                          }}
                        >
                          <QRCode
                            bgColor="#FFFFFF"
                            fgColor="#000000"
                            level="H"
                            value={JSON.stringify({
                              event_id: data?.event_id?.event_id,
                              name: data?.user_details?.name,
                              event_request_id: data?.event_request_id,
                              event_type: data?.event_type,
                            })}
                          />
                        </div>
                        <hr />
                        <Row>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1 border-right">
                              <div className="f14-400 mb-1">
                                Seating Preference
                              </div>
                              <div className="f14-500">
                                {data?.seating_preference.length > 0
                                  ? data?.seating_preference.map(
                                      (prefs, index) =>
                                        index + 1 ===
                                        data?.seating_preference?.length
                                          ? `${prefs}`
                                          : `${prefs},`
                                    )
                                  : "-"}
                              </div>
                            </div>
                          </Col>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1 border-right">
                              <div className="f14-400 mb-1">
                                Special Occasion
                              </div>
                              <div className="f14-500">
                                {data?.occasion || "-"}
                              </div>
                            </div>
                          </Col>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1 border-right ">
                              <div className="f14-400 mb-1">Payment Status</div>
                              <div className="f14-500">
                                {PAYMENT_STATUS[data?.payment_status]}
                              </div>
                            </div>
                          </Col>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1 border-right">
                              <div className="f14-400 mb-1">Status</div>
                              <div className="f14-500">
                                {data?.event_status}
                              </div>
                            </div>
                          </Col>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1">
                              <div className="f14-400 mb-1">Requested Date</div>
                              <div className="f14-500">
                                {moment(data?.createdAt).format("Do MMM, YYYY")}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1 border-right">
                              <div className="f14-400 mb-1">
                                Membership Level
                              </div>
                              <div className="f14-500">-</div>
                            </div>
                          </Col>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1 border-right">
                              <div className="f14-400 mb-1">Membership ID</div>
                              <div className="f14-500">-</div>
                            </div>
                          </Col>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1 border-right">
                              <div className="f14-400 mb-1">Requested Time</div>
                              <div className="f14-500">
                                {moment(data?.createdAt).format("hh:mm A")}
                              </div>
                            </div>
                          </Col>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1 border-right">
                              <div className="f14-400 mb-1">
                                Last Change Date
                              </div>
                              <div className="f14-500">
                                {moment(data?.updatedAt).format("Do MMM, YYYY")}
                              </div>
                            </div>
                          </Col>
                          <Col md={2} xs={6}>
                            <div className=" mobile-mt-1">
                              <div className=" f14-400 mb-1">
                                Last Change Time
                              </div>
                              <div className="f14-500">
                                {moment(data?.updatedAt).format("hh:mm A")}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <Row>
                      <Col md={6} xs={12}>
                        <div className="f12-500 mt-2 mb-1">
                          {" "}
                          *Terms and Conditions
                        </div>
                        <div>
                          <ol className="f10-400">
                            <li>{data?.event_id?.terms_and_condition || ""}</li>
                          </ol>
                        </div>
                        <div className="f12-500 mt-5 mb-1">
                          {" "}
                          *Refund & cancellation
                        </div>
                        {console.log("data?.event_id ===>", data?.event_id)}
                        <div>
                          <ol className="f10-400">
                            <li>
                              {data?.event_id?.refund_and_cancellation || ""}
                            </li>
                          </ol>
                        </div>
                      </Col>
                      <Col md={6} xs={12}>
                        <div className="f12-500 mt-2 mb-1">
                          {" "}
                          *Covid Protocol
                        </div>
                        <div>
                          <ol className="f10-400">
                            <li>
                              Patrons above 18 years of age, who are fully
                              vaccinated (both doses) with Covid-19 vaccine and
                              have completed 14 days after their second dose
                              will be allowed entry for the event.
                            </li>
                            <li>
                              For safety purposes, wearing a mask is mandatory.
                            </li>
                            <li>
                              Patrons with fever (Body Temperature {">"}99.2F)
                              or other symptoms like: Cough etc. will not be
                              allowed entry and are requested to stay at home.
                            </li>
                            <li>
                              Keep at least a 1 metre distance from others.
                            </li>
                            <li>Avoid crowded or poorly ventilated areas.</li>
                            <li>
                              Cover coughs and sneezes with bent elbow or
                              tissues; and
                            </li>
                            <li>Clean your hands frequently</li>
                          </ol>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default EventQrCodePublicDisplay;
